const o = (r) => Array.from({ length: r }, (a, e) => e + 1);
export {
  o as generateNumberArray
};
